import { Stack, Grid, Typography, useMediaQuery, Divider, Box } from "@mui/material"
import ShadowBox from "components/ShadowBox";
import StatisticCircle from "components/StatisticCircle"
import StatisticLine from "components/StatisticLine"
import { useTranslation } from "react-i18next";

export default function Statistics({data}) {

    const { t } = useTranslation();
    const matches = useMediaQuery('(min-width:500px)');

    return <ShadowBox flexDirection="column" alignItems="center" sx={{ pb: 2, mt: 1 }}>
        <Typography variant="body1" fontWeight="bold" color="text.primary_bold" sx={{mb: 1, alignSelf: "flex-start", textAlign: "left", mt: 1, ml: 1.5}}>
            {t("statistics.title")}
        </Typography>
        <Divider sx={{width: "100%", mb: 1}}/>
        
        <Grid container sx={{mt: 0, width: matches ? "80%" : "100%"}} spacing={2}>
            <Grid item xs={6} sm={6} sx={{display: "flex", alignContent: "center", justifyContent: "center"}}>
                <StatisticCircle width="100%" style={{maxWidth: 160}} statistic={t("statistics.singlesWon")} left={data["singles"]["nw"]} right={data["singles"]["nm"] - data["singles"]["nw"]}/>
            </Grid>
            <Grid item xs={6} sm={6} sx={{display: "flex", alignContent: "center", justifyContent: "center"}}>
                <StatisticCircle width="100%" style={{maxWidth: 160}} statistic={t("statistics.doublesWon")} left={data["doubles"]["nw"]} right={data["doubles"]["nm"] - data["doubles"]["nw"]}/>
            </Grid>
        </Grid> 

         <Typography variant="body1" color="text.primary" sx={{px: 1.5, pb: 0.5, fontWeight: "bold", alignSelf: "center"}} component="div">
        {t("common.singles")}
        </Typography>
        
        <Box sx={{px: 2, gap: 1, width: "100%"}}>
            <StatisticLine statistic={t("statistics.setsWon")} left={data["singles"]["nsw"]} right={data["singles"]["nsp"] - data["singles"]["nsw"]}/>
            <StatisticLine statistic={t("statistics.gamesWon")} left={data["singles"]["ngw"]} right={data["singles"]["ngp"] - data["singles"]["ngw"]}/>
            <StatisticLine statistic={t("statistics.tiebreaksWon")} left={data["singles"]["ntw"]} right={data["singles"]["ntp"] - data["singles"]["ntw"]}/>
        </Box>

        <Typography variant="body1" color="text.primary" sx={{px: 1.5, pt: 3, pb: 0.5, fontWeight: "bold", alignSelf: "center"}} component="div">
        {t("common.doubles")}
        </Typography>

        <Box sx={{px: 2, gap: 1, width: "100%"}}>
            <StatisticLine statistic={t("statistics.setsWon")} left={data["doubles"]["nsw"]} right={data["doubles"]["nsp"] - data["doubles"]["nsw"]}/>
            <StatisticLine statistic={t("statistics.gamesWon")} left={data["doubles"]["ngw"]} right={data["doubles"]["ngp"] - data["doubles"]["ngw"]}/>
            <StatisticLine statistic={t("statistics.tiebreaksWon")} left={data["doubles"]["ntw"]} right={data["doubles"]["ntp"] - data["doubles"]["ntw"]}/>
        </Box>
    </ShadowBox>
}